import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-3" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Roles", -1)

import { Role } from "@/classes";
import { useConfirmStore } from "@/store/confirm";
import { useListStore } from "@/store/lists";
import { onMounted, onUnmounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RoleSettings',
  setup(__props) {

const $confirm = useConfirmStore();
const lists = useListStore();

const roles = ref<Role[]>([]);
onMounted(async () => {
  roles.value = await Role.list();
  roles.value.sort((a, b) => a.created.getTime() - b.created.getTime());
});
onUnmounted(() => {
  lists.refreshList("roles");
});

const createRole = async () => {
  const newRole = new Role();
  await newRole.save();
  roles.value.push(newRole);
};

const deleteRole = async (role: Role) => {
  $confirm.open({
    onConfirm: async () => {
      roles.value = roles.value.filter((d) => d.id !== role.id);
      await role.deleteObject();
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        color: "primary",
        flat: "",
        onClick: createRole
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { class: "mr-1" }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-plus")
            ]),
            _: 1
          }),
          _createTextVNode("Role ")
        ]),
        _: 1
      })
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (role) => {
      return (_openBlock(), _createElementBlock("div", {
        key: role.id,
        class: "d-flex align-center mt-2"
      }, [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: role.name,
                  "onUpdate:modelValue": ($event: any) => ((role.name) = $event),
                  label: "Name",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  "onUpdate:focused": ($event: any) => (!$event && role.save())
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onUpdate:focused"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_v_btn, {
          class: "ml-2",
          icon: "mdi-delete",
          flat: "",
          density: "compact",
          onClick: ($event: any) => (deleteRole(role))
        }, null, 8, ["onClick"])
      ]))
    }), 128))
  ]))
}
}

})